import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface CombinedVaccineParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface CombinedVaccine { 

    id?:number;
    medicineId:string;
    vaccineCategoryId:number;
    branchId: string;
    tenantId: string;  
    
    parameters?: CombinedVaccineParameter[];
    links?: any;
}


export abstract class CombinedVaccineData {
    abstract list(url: string): Observable<any>; 
    abstract getById(url: string): Observable<any>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract getall(url: string): Observable<CombinedVaccine[]>;
    abstract create(url: string, data: CombinedVaccine): Observable<CombinedVaccine[]>;
    abstract update(url: string, data: CombinedVaccine): Observable<CombinedVaccine>;
    abstract delete(url: string): Observable<any>;
}
